import { Component } from '@angular/core';

@Component({
  selector: 'prof-internal-user-error',
  templateUrl: './internal-user-error.component.html',
  styleUrl: './internal-user-error.component.scss',
  standalone: false
})
export class InternalUserErrorComponent {

}
